export default __webpack_public_path__ + "static/media/id-wrong_s.c8bcbd58.jpg";